export const colors = {
  primary: {
    main: '#007DAA',
    dark: '#004A6C',
    light: '#56A5CB',
  },
  secondary: {
    main: '#745CA1',
    dark: '#463272',
    light: '#A489D3',
  },
  info: {
    main: '#2196F3',
    dark: '#0B79D0',
    light: '#64B6F7',
  },
  error: {
    main: '#F44336',
    dark: '#E31B0C',
    light: '#F88078',
  },
  success: {
    main: '#587F1B',
    dark: '#2A5200',
    light: '#88AF4A',
    alert: {
      content: '#4CAF50',
    },
  },
  warning: {
    main: '#ED6C02',
    dark: '#C77700',
    light: '#FFB547',
  },
}
